




















































import {
    computed,
    defineComponent,
    onActivated,
    onDeactivated,
    onMounted,
    ref,
    watch,
} from '@vue/composition-api';

import { SdsIcon } from '@superbet-group/web.lib.ui-components';

import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';

const MAX_SCROLLING_WIDTH = 9999;

export default defineComponent({
    name: 'ExtendedEventCardHorizontalScroll',
    props: {
        shouldUseInMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const showShadowStart = ref(false);
        const showShadowEnd = ref(false);
        const isNavShown = ref(false);
        const isMobile = computed(() => isMobileLayout() && !props.shouldUseInMobile);

        const scrollContainerRef = ref<HTMLElement>();

        function scrollToLeft() {
            scrollContainerRef.value?.scrollTo({
                left: scrollContainerRef.value.scrollLeft - MAX_SCROLLING_WIDTH,
                behavior: 'smooth',
            });
        }

        function scrollToRight() {
            scrollContainerRef.value?.scrollTo({
                left: scrollContainerRef.value.scrollLeft + MAX_SCROLLING_WIDTH,
                behavior: 'smooth',
            });
        }

        function toggleShadow() {
            if (isMobile.value) {
                return;
            }

            const { scrollLeft, scrollWidth, offsetWidth } = scrollContainerRef.value;

            showShadowStart.value = scrollLeft > 0;

            showShadowEnd.value = Math.round(scrollLeft) + offsetWidth < scrollWidth;
        }

        function checkScrollability() {
            const { scrollWidth, clientWidth } = scrollContainerRef.value;

            const isScrollable = scrollWidth > clientWidth;

            showShadowEnd.value = isScrollable && !isMobile.value;
        }

        watch(() => isMobile.value, () => checkScrollability());

        onMounted(() => {
            checkScrollability();
        });

        onActivated(() => {
            checkScrollability();
        });

        onDeactivated(() => {
            showShadowStart.value = false;
        });

        return {
            isMobile,
            showShadowStart,
            showShadowEnd,
            toggleShadow,
            isNavShown,
            scrollToLeft,
            scrollToRight,
            scrollContainerRef,
        };
    },

    components: { SdsIcon },
});
